export const getImageUrl = (imagePath) => {
  console.log('[getImageUrl] imagePath:', imagePath);
  
  if (!imagePath) return null;

  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  const cleanedPath = imagePath.replace(/^\/api\//, '/');
  
  // For development: use full backend URL
  // For production: use relative path with proxy or REACT_APP_IMAGE_URL
  const baseUrl = process.env.REACT_APP_IMAGE_URL || 'http://localhost:5001';
  return `${baseUrl}/${cleanedPath.replace(/^\//, '')}`;
};
